import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useHistory } from 'react-router-dom';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import MyLoader from './util/loader'
import Api from './api/api'
import showToast from './util/toast'
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import menu_icon from '../assets/menu_icon.png';
import Rating from '@mui/material/Rating';
import banner from '../assets/banner.jpeg';
import plumber from '../assets/plumber.png';
import paint from '../assets/paint.png';
import aircon from '../assets/aircon.png';
import mover from '../assets/mover.png';
import worker from '../assets/worker.jpg';
import industry from '../assets/industry.jpg';
import done from '../assets/done.png';
import * as Colors from './colors'
import { useSelector } from 'react-redux';
import { categories, categories1, caribbeanCities } from './util/cats'

const Home = () => {
    const history = useHistory()

    let user = useSelector(state => state.MyReducer.user);
    if (user == null && localStorage.getItem('user') != null) {
        user = JSON.parse(localStorage.getItem('user'))
    }

    const [catId, setCatId] = useState('');

    const cats = categories1
    const [selectedCat, setSelectedCat] = useState(cats[0])
    const [selectedLocation, setSelectedLocation] = useState(caribbeanCities[0])

    const showCatTab = (cat) => {
        return (
            <button
                onClick={() => {
                    // history.push('/vendors/' + cat.title)
                }}
                className='cat-tab' style={{ border: '0px', marginLeft: 10, marginRight: 10, marginTop: 10, alignItems: 'center', justifyContent: 'center' }}>
                {/* <img
                    src={cat.icon}
                    style={{ width: 60, height: 60, objectFit: 'contain', alignSelf: 'center' }} /> */}
                <div style={{ marginLeft: 10, alignSelf: 'center', fontSize: 18 }}>
                    {cat}
                </div>
            </button>
        )
    }

    const showPros = (type, pros) => {
        return (
            <div
                className='home-panel'
                style={{ alignSelf: 'center', display: 'flex', flexDirection: 'column', flexWrap: "wrap", marginTop: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className='home-label'>
                        {type}
                    </div>
                    <a
                        style={{ marginTop: 20, marginLeft: 20, fontSize: 22, textDecoration: 'none' }}
                        href='/'>
                        View All
                    </a>
                </div>
                <div style={{ marginTop: 0, marginLeft: 20, fontSize: 15 }}>
                    Get quotes and quality workmanship from local professionals
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
                    {pros.map((item, index) => {
                        return (
                            <div className='pro-item' style={{ marginLeft: 10, marginRight: 10, marginTop: 20, alignItems: 'center', justifyContent: 'center' }}>
                                <img
                                    src={'https://picsum.photos/seed/picsum/200/300'}
                                    style={{}} />
                                <div style={{ display: 'flex', marginTop: 5, height: 35 }}>
                                    <Rating
                                        name="simple-controlled"
                                        value={5}
                                        onChange={(event, newValue) => {
                                            // setValue(newValue);
                                        }}
                                    />
                                    <p style={{ fontSize: 18, marginTop: 2 }}>4.8</p>
                                    <p style={{ marginLeft: 5, fontSize: 18, marginTop: 2, color: 'gray' }}>(20 Reviews)</p>
                                </div>
                                <div style={{ fontSize: 20, marginTop: -5 }}>
                                    Service Title
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    };

    const showStep = (step, stepTxt) => {
        return (
            <div className='step-parent' style={{ marginLeft: 10, marginRight: 10, marginTop: 10 }}>
                <div className='step'>
                    <div>{step}</div>
                </div>
                <div className='step-txt'>
                    {stepTxt}
                </div>
            </div>
        )
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#f2f2f2', flex: 1 }}>

            <img
                style={{ width: '100%', objectFit: 'contain' }}
                src={banner} />

            <div
                className='home-panel'
                style={{ display: 'flex', flexDirection: 'column', paddingBottom: 15, backgroundColor: 'white', alignSelf: 'center', borderRadius: 10, marginTop: 20, zIndex: 10 }}>

                <div className='home-label'>
                    Latest Promotion
                </div>

                <img
                    onClick={() => {
                        //
                    }}
                    src={'https://picsum.photos/seed/picsum/200/300'}
                    style={{ width: '96%', height: 150, marginTop: 10, objectFit: 'cover', alignSelf: 'center' }} />
            </div>

            <div style={{ width: '100%', marginTop: 20, paddingBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className='home-panel'
                    style={{ alignSelf: 'center' }}>
                    <div className='home-label' style={{ alignSelf: 'center' }}>
                        Get Work Done for Any Industry!
                    </div>

                    <div className='join-panel'>
                        <div
                            style={{ alignSelf: 'center', display: 'flex', flexWrap: "wrap", marginTop: 10, alignItems: 'center', justifyContent: 'center' }}>
                            {categories.map((item, index) => {
                                if (index >= 12)
                                    return null
                                return showCatTab(item)
                            })}
                        </div>
                        <img
                            style={{ width: '100%', borderRadius: 10, marginTop: 20, objectFit: 'contain' }}
                            src={industry} />
                    </div>

                    <div style={{alignSelf:'center', display:'flex', alignItems:'center',justifyContent:'center'}}>
                        <button
                            className='search-btn1'
                            style={{ marginTop: 0, alignSelf: 'center', height: 50, width: 500 }}
                            onClick={() => {
                                history.push({
                                    pathname: '/post-job'
                                })
                            }}>
                            Post a Job Now
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ width: '100%', backgroundColor: 'white', marginTop: 20, paddingBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className='home-panel'
                    style={{ alignSelf: 'center' }}>
                    <div className='home-label'>
                        How to Use Cariworks!
                    </div>
                    <div
                        style={{ flexDirection: 'row', alignSelf: 'center', display: 'flex', flexWrap: "wrap", marginTop: 10, alignItems: 'flex-start', justifyContent: 'center' }}>
                        {showStep(1, 'Choose the service you need and fill in the request form')}
                        {showStep(2, 'Pro will contact you. Book an appointment immediately, or get quotations first')}
                        {showStep(3, 'When your Job is done, Give a rating & review to the Pro')}
                    </div>
                </div>
            </div>

            {/* {showPros('Plumber', plumberPros)} */}
            {/* {showPros('House Painting', paintPros)} */}
            {/* {showPros('Aircon Servicing', airconPros)} */}
            {/* {showPros('Domestic Mover', moverPros)} */}

            <div style={{ width: '100%', marginTop: 20, paddingBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className='home-panel'
                    style={{ alignSelf: 'center' }}>

                    <div className='join-panel'>
                        <div>
                            <div className='home-label'>
                                Have any skill to provide services?
                            </div>
                            <div style={{ fontSize: 22, marginLeft: 20, marginTop: 10 }}>
                                We have customers waiting for you.
                            </div>
                            <div style={{ fontSize: 22, marginLeft: 20 }}>
                                Join our network and grow your business starting today.
                            </div>
                            <button
                                className='search-btn'
                                style={{ marginTop: 20, height:50, marginLeft: 20, width: 250 }}
                                onClick={() => {
                                    history.push({
                                        pathname: '/signup',
                                        state: { type: 'vendor' }
                                    })
                                }}>
                                Join Now
                            </button>
                        </div>
                        <img
                            className='join-panel-img'
                            style={{ objectFit: 'contain' }}
                            src={worker} />
                    </div>

                </div>
            </div>

            <div
                className='home-panel'
                style={{ display: 'flex', flexDirection: 'column', paddingBottom: 15, paddingBottom: 30, marginBottom: 50, backgroundColor: 'white', alignSelf: 'center', borderRadius: 10, marginTop: 0, zIndex: 10 }}>

                <div className='home-label' id='our-services'>
                    Search Jobs
                </div>
                {/* <div style={{ marginTop: 0, marginLeft: 20, fontSize: 15 }}>
                    Choose a service to get a quoation.
                </div> */}

                <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: 15, marginRight: 15, marginTop: -5 }}>
                    <div class="select_box" style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}>
                        <select
                            className='picker'
                            onChange={(e) => {
                                let val = e.target.value
                                console.log('val: ' + val);
                                setSelectedCat(val)
                            }}>
                            {categories1.map((item, index) => {
                                return (
                                    <option value={item}>{item}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div class="select_box" style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}>
                        <select
                            className='picker'
                            onChange={(e) => {
                                setSelectedLocation(e.target.value)
                            }}>
                            {caribbeanCities.map((item, index) => {
                                return (
                                    <option
                                        value={item}>
                                        {item}
                                    </option>
                                )
                            })}
                        </select>
                    </div>
                    <button
                        className='search-btn'
                        style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}
                        onClick={() => {
                            console.log('job_type1: ' + selectedCat);
                            console.log('state1: ' + selectedLocation);
                            history.push({
                                pathname: '/search-jobs',
                                state: {
                                    job_type: selectedCat,
                                    location: selectedLocation,
                                }
                            })
                        }}>
                        Search
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Home;